export default function preloadFont(fontUrl) {
  const alreadyLinked = Array.from(document.head.querySelectorAll('link[rel="stylesheet"]'))
    .some((link) => link.getAttribute('href') === fontUrl)
  if (alreadyLinked) return
  const linkElement = document.createElement('link')
  linkElement.rel = 'stylesheet'
  linkElement.href = fontUrl
  document.head.appendChild(linkElement)
}

const DEFAULT_FONT_KEYS = ['jakarta', 'cairo']

const isLazyFont = (font) => font.url && !DEFAULT_FONT_KEYS.includes(font.name)

export function findThemeFont(fonts, fontFamily) {
  if (!fontFamily) return null
  return Object.values(fonts).find(
    (font) => isLazyFont(font)
      && (font.label === fontFamily || font.value.startsWith(`'${fontFamily}'`)),
  ) || null
}

export function loadThemeFont(fonts, fontFamily) {
  const font = findThemeFont(fonts, fontFamily)
  if (font) preloadFont(font.url)
}

let remainingFontsScheduled = false

// Slide text can carry an inline font-family from the editor's font menu, so every
// built-in family must still be linked, just off the critical path.
export function preloadRemainingFontsWhenIdle(fonts) {
  if (remainingFontsScheduled) return
  remainingFontsScheduled = true
  const schedule = window.ahaAfterInteractive || ((callback) => setTimeout(callback, 0))
  schedule(() => {
    Object.values(fonts).filter(isLazyFont).forEach((font) => preloadFont(font.url))
  })
}
